export default __webpack_public_path__ + "7853c71223701f30d495bafd80fdef13.svg";